<template>
    <div class="category-icon">
        <svg v-if="selected" width="57" height="57" :viewBox="viewBox" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.209 26.9717L21.0801 53.5938L0 40.7051L0.0644531 14.083L21.209 26.9717Z" :fill="currentColor" />
            <path d="M43.4951 40.7051L22.3496 53.5938L22.4141 26.9717L43.4941 14.083L43.4951 40.7051Z"
                :fill="currentColor" />
            <path d="M42.9209 12.8896L21.8438 25.7812L0.761719 12.8896L21.8408 0L42.9209 12.8896Z"
                :fill="currentColor" />
        </svg>
        <svg v-else width="57" height="57" :viewBox="viewBox" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.7002 0.145508C22.8736 0.0188098 23.102 0.0188031 23.2754 0.145508L23.2793 0.147461L45.6289 13.877L45.6406 13.8848H45.6553C45.6615 13.8848 45.6633 13.8849 45.6797 13.9033C45.6929 13.9182 45.7162 13.9437 45.7559 13.9521L45.8096 14.0107C45.9331 14.1471 45.9786 14.2681 45.9316 14.376L45.9277 14.3848V14.3955L45.8633 42.6299V42.7012C45.8633 42.7356 45.8629 42.7841 45.8555 42.832C45.8479 42.8813 45.8337 42.9218 45.8115 42.9463C45.7471 43.0174 45.6855 43.0862 45.6211 43.1572L45.6074 43.1719V43.1904C45.6074 43.2004 45.6052 43.2049 45.6045 43.2061C45.6038 43.2071 45.6031 43.2081 45.6016 43.209C45.5995 43.2101 45.5962 43.2115 45.5938 43.2119H45.5791L45.5674 43.2197L23.2852 56.8809C23.2216 56.8842 23.1721 56.9019 23.1289 56.918C23.081 56.9358 23.0406 56.9502 22.9873 56.9502C22.9231 56.9502 22.8642 56.9495 22.8135 56.9414C22.7627 56.9333 22.7281 56.9187 22.707 56.8955L22.7021 56.8896L22.6963 56.8857L0.365234 43.2363C0.362384 43.2234 0.358997 43.2109 0.352539 43.2002C0.341217 43.1816 0.325788 43.169 0.311523 43.1611C0.300664 43.1552 0.289909 43.1525 0.28125 43.1504C0.252953 43.1192 0.225136 43.0884 0.197266 43.0576C0.168549 43.0259 0.139532 42.9941 0.110352 42.9619C0.108318 42.9452 0.106722 42.9276 0.102539 42.9111C0.0961218 42.8859 0.0880338 42.8579 0.0800781 42.832C0.072019 42.8059 0.0642243 42.7812 0.0585938 42.7588C0.052787 42.7356 0.0498047 42.7175 0.0498047 42.7061V42.6357L0.114258 14.4014C0.114258 14.2741 0.168578 14.1463 0.232422 14.0078L0.28125 13.9541C0.32026 13.9454 0.343079 13.9202 0.355469 13.9062C0.37099 13.8888 0.373768 13.8877 0.381836 13.8877H0.396484L0.408203 13.8799L22.6963 0.147461L22.7002 0.145508ZM44.6768 15.6182L23.5967 28.5068L23.5723 28.5215V28.5498L23.5078 55.1719V55.2607L23.584 55.2148L44.7285 42.3252L44.7529 42.3105V42.2822L44.752 15.6602V15.5713L44.6768 15.6182ZM23.0234 1.53516L1.94336 14.4248L1.87305 14.4678L1.94336 14.5098L23.0254 27.4023L23.0518 27.418L23.0781 27.4023L44.1553 14.5098L44.2256 14.4678L44.1553 14.4248L23.0752 1.53516L23.0488 1.51953L23.0234 1.53516ZM22.4678 28.5215L22.4434 28.5068L1.29883 15.6182L1.22266 15.5713V15.6602L1.1582 42.2822V42.3105L1.18164 42.3252L22.2617 55.2148L22.3379 55.2607V55.1719L22.4668 28.5498L22.4678 28.5215Z"
                :fill="currentColor" stroke="black" stroke-width="0.1" />
        </svg>
        <div v-if="hasText" class="navbar-text-desc">
            <p>3d works</p>
        </div>
    </div>
</template>

<style scoped>
.category-icon {
    width: v-bind(width);
    height: v-bind(height);
    display: flex;
    gap: 4px;
    margin-right: -11px;
}

svg {
    height: v-bind(height);
}

.navbar-text-desc p {
    width: 40px;
}

@media (max-width: 996px) {
    .category-icon {
        margin-right: 0;
        margin-left: 2px !important; 
    }
}

@media (max-width: 390px) {
    .category-icon {
        margin-left: 3px !important; 
        gap: 4px !important;
    }
}
</style>

<script setup>
import { useThemeStore } from '@/stores/useThemeStore';
import { computed } from 'vue';

const currentColor = computed(() => (useThemeStore.isDark ? "#E8E8E8" : "#000000"))

const props = defineProps({
    selected: {
        type: Boolean,
        default: false
    },
    hasText: {
        type: Boolean,
        default: false
    },
    width: {
        type: String,
        default: '153px'
    },
    height: {
        type: String,
        default: 'auto'
    },
    viewBox: {
        type: String,
        default: "0 0 57 57"
    }
})
</script>